/* eslint-disable no-else-return */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable operator-assignment */
/* eslint-disable import/order */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable spaced-comment */
/* eslint-disable object-shorthand */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import * as CryptoJS from 'crypto-js';
import {
  VariationItem,
  Variation,
  DeliveryArea,
  MerchantsState,
  Product,
  Category,
} from '../store/ducks/merchants/types';
import {
  Variation as VariationOrder,
  Product as ProductOrder,
  Stock,
} from '../store/ducks/order/types';
import { removeSpecialChars } from './mask';
import { checkVariations } from './validation';
import { IDataApp, Month } from './types';
import { LocalStorageName } from '../utils/Utils';
import { jwtRequest } from './api';

const secretKey = process.env.REACT_APP_SECRET_KEY as string;

export const checkItem = (
  list: VariationOrder[],
  variationItem: VariationItem,
) => {
  const temp: VariationOrder[] = list.filter(
    (variationOrder: VariationOrder) =>
      variationOrder.variationItemId === variationItem.id,
  );

  return temp.length > 0;
};

export const getVariationItemQuantity = (
  list: VariationOrder[],
  variationItem: VariationItem,
) => {
  const temp: VariationOrder[] = list.filter(
    (variationOrder: VariationOrder) =>
      variationOrder.variationItemId === variationItem.id,
  );
  if (temp.length > 0) {
    // console.log('temp', temp);
    return temp[0].quantity;
  }
  return 0;
};

export const verifyVariationRange = (
  list: VariationOrder[],
  variation: Variation,
  variationItem: VariationItem,
) => {
  const temp: VariationOrder[] = list.filter(
    // eslint-disable-next-line arrow-body-style
    (variationOrder: VariationOrder) => {
      return variationOrder.variationId === variationItem.variationId;
    },
  );
  // Encontrados itens inseridos
  if (temp.length > 0) {
    const compare = temp.reduce(
      (sum: number, current: VariationOrder) => sum + current.quantity,
      0,
    );
    // Verificação da quantidade máxima de itens escolhidos
    if (compare < variation.itemsMax) {
      return true;
    }
    return false;
  }
  return true;
};

export const handleVariationItemQuantity = (
  list: VariationOrder[],
  variation: Variation,
  variationItem: VariationItem,
  action: number,
  variationsGrid: boolean,
) => {
  const newList: VariationOrder[] = list;
  // Verificar se o item existe na lista
  const temp: VariationOrder[] = list.filter(
    (variationOrder: VariationOrder) =>
      variationOrder.variationItemId === variationItem.id,
  );
  // console.log('list', list);
  // console.log('variationItem', variationItem);
  // console.log('action', action);
  if (temp.length > 0) {
    // Item existe
    const index = list.indexOf(temp[0]);
    if (action === 0) {
      // subtrair item
      if (temp[0].quantity > 1) {
        newList[index].quantity -= 1;
      } else {
        // remover item da lista
        newList.splice(index, 1);
      }
    }
    if (action === 1) {
      // adicionar item
      newList[index].quantity += 1;
    }
    // console.log('item existe', newList);
  } else {
    // Item não existe
    newList.push({
      variationId: variationItem.variationId,
      variationName: variation.name,
      variationItemId: variationItem.id,
      variationItemName: variationItem.name,
      quantity: 1,
      value: variationItem.value,
      variationsGrid,
      variationItemAvailability: variationItem.availability,
      variationItemStockActive: variationItem.stock.active,
      variationItemStockCurrent: variationItem.stock.current,
      variationItemsMax: variation.itemsMax,
    });
    // console.log('item não existente', newList);
  }
  // console.log('newlist final', newList);

  return newList;
};

export const handleSingleItem = (
  list: VariationOrder[],
  variation: Variation,
  variationItem: VariationItem,
  variationsGrid: boolean,
) => {
  const newList: VariationOrder[] = list;
  // Verificar se o item da variação existe na lista
  const temp: VariationOrder[] = list.filter(
    (variationOrder: VariationOrder) =>
      variationOrder.variationItemId === variationItem.id,
  );
  if (temp.length > 0) {
    // console.log('Existe item da variação na lista, removendo da lista');
    const index = list.indexOf(temp[0]);
    newList.splice(index, 1);
  } else {
    // Verificar se existe algum item daquela variação na lista
    //console.log('Verificar se existe algum item daquela variação na lista');
    const checkExistVariationItemOnList = newList.filter(
      (result: VariationOrder) =>
        result.variationId === variationItem.variationId,
    );
    //console.log(checkExistVariationItemOnList);
    if (checkExistVariationItemOnList.length > 0) {
      // Existe algum item da variação dentro da lista
      // console.log(
      //   'Existe item da variação na lista, removendo item e atualizando a lista',
      // );
      const index = newList.indexOf(checkExistVariationItemOnList[0]);
      newList.splice(index, 1);
      newList.push({
        variationId: variationItem.variationId,
        variationName: variation.name,
        variationItemId: variationItem.id,
        variationItemName: variationItem.name,
        quantity: 1,
        value: variationItem.value,
        variationsGrid,
        variationItemAvailability: variationItem.availability,
        variationItemStockActive: variationItem.stock.active,
        variationItemStockCurrent: variationItem.stock.current,
        variationItemsMax: variation.itemsMax,
      });
    } else {
      // Não existe item da variação dentro da lista
      //console.log('Não existe item daquela variação na lista');
      newList.push({
        variationId: variationItem.variationId,
        variationName: variation.name,
        variationItemId: variationItem.id,
        variationItemName: variationItem.name,
        quantity: 1,
        value: variationItem.value,
        variationsGrid,
        variationItemAvailability: variationItem.availability,
        variationItemStockActive: variationItem.stock.active,
        variationItemStockCurrent: variationItem.stock.current,
        variationItemsMax: variation.itemsMax,
      });
    }
  }
  //console.log('Lista de variações: ', newList);
  return newList;
};

export const removeSingleItem = (
  list: VariationOrder[],
  variation: Variation,
  variationItem: VariationItem,
) => {
  console.log('remover item único');
  const newList: VariationOrder[] = list;
  // Verificar se o item existe na lista
  const temp: VariationOrder[] = list.filter(
    // eslint-disable-next-line arrow-body-style
    (variationItemTemp: VariationOrder) => {
      return variationItemTemp.variationItemId === variationItem.variationId;
    },
  );

  const index = list.indexOf(temp[0]);

  return newList.splice(index, 1);
};

export const checkRequired = (
  list: VariationOrder[],
  variations: Variation[],
  variationGrid: boolean,
) => {
  const result: boolean[] = [];
  let throwError = 0;
  if (variationGrid) {
    // Tipo de grade com variação
    if (list.length > 0) {
      // Ao menos um item foi selecionado
      result.push(true);
      return result;
    }
    // Nenhum item selecionado
    const requiredArray: string[] = [];
    variations.map((variationTemp: Variation) => {
      if (variationTemp.items.length > 0) {
        requiredArray.push(variationTemp.name);
      }
      return true;
    });
    if (variations.length === 0) {
      result.push(true);
      return result;
    }
    checkVariations('vazio', requiredArray);
    result.push(false);
    return result;
  }
  // Varrer lista de variações e detectar itens obrigatórios
  const requiredVariationsList = variations.filter(
    (variation: Variation) => variation.required === true,
  );
  // console.log('Lista de variações obrigatórias:', requiredVariationsList);

  if (requiredVariationsList.length > 0) {
    // Possui variações obrigatórias
    const requiredVariationsItemsList: VariationOrder[] = [];
    // Varrer variações e encontrar as variações que são necessárias
    list.map((variationOrder: VariationOrder) => {
      requiredVariationsList.filter((variationTemp: Variation) => {
        if (variationTemp.id === variationOrder.variationId) {
          requiredVariationsItemsList.push({ ...variationOrder });
        }
        return true;
      });
      return true;
    });
    const comparator = requiredVariationsItemsList.reduce(
      (agroup: string[], current: VariationOrder) => {
        if (
          agroup.length === 0 ||
          agroup.filter((i: string) => i === current.variationId).length === 0
        ) {
          agroup.push(current.variationId);
        }
        return agroup;
      },
      [],
    );
    if (comparator.length >= requiredVariationsList.length) {
      // Verificar se respeita o min e max de itens
      requiredVariationsItemsList.map((variationOrderItem: VariationOrder) => {
        // Agrupa itens da mesma variação
        const agroupItems = requiredVariationsItemsList.filter(
          (variationOrderItemTemp: VariationOrder) =>
            variationOrderItemTemp.variationId ===
            variationOrderItem.variationId,
        );
        //console.log('Itens da mesma variação:', agroupItems);
        if (agroupItems.length > 1) {
          // Mais de um item da variação
          //console.log('Mais de um item da variação encontrado');
          const quantitySum = agroupItems.reduce(
            (sum: number, current: VariationOrder) => sum + current.quantity,
            0,
          );
          // Buscar itemsMin e itemsMax da variação à qual o variationItem pertence
          const variationData = variations.filter(
            (variationFiltered: Variation) =>
              variationFiltered.id === agroupItems[0].variationId,
          )[0];
          // console.log('variationData', variationData);
          // console.log('quantitySum', quantitySum);
          // console.log('variationData.itemsMin', variationData.itemsMin);

          if (quantitySum >= variationData.itemsMin) {
            // Quantidade mínima respeitada
            //console.log('Quantidade mínima respeitada - múltipla');
            result.push(true);
            // return result;
          } else {
            // Quantidade mínima não respeitada;
            console.log('Quantidade mínima NÃO respeitada - múltipla');
            if (throwError === 0) {
              throwError = 1;
              checkVariations('minimo', [variationData.name]);
            }
            result.push(false);
            // return result;
          }
          // return result;
        } else {
          // Nenhum item a mais de variação
          const variationData = variations.filter(
            (variationFiltered: Variation) =>
              variationFiltered.id === variationOrderItem.variationId,
          )[0];

          // console.log('variationData', variationData);
          // console.log('Item único da variação');
          if (variationOrderItem.quantity >= variationData.itemsMin) {
            // Quantidade mínima respeitada
            // console.log('Quantidade mínima respeitada única');
            result.push(true);
            // return result;
          } else {
            if (throwError === 0) {
              throwError = 1;
              checkVariations('minimo', [variationData.name]);
            }
            console.log('Quantidade mínima NÃO respeitada única');
            result.push(false);
            // return result;
          }
        }
        return true;
      });
      // return result;
    } else {
      const variationsError: Variation[] = [];
      requiredVariationsList.map((variation: Variation) => {
        const errorsTemp: VariationOrder[] = requiredVariationsItemsList.filter(
          (variationOrder: VariationOrder) =>
            variationOrder.variationId === variation.id,
        );
        if (errorsTemp.length === 0) {
          // Variação pendente
          variationsError.push(variation);
        }
        return variationsError;
      });
      // Lista de variações obrigatórias pendentes
      const requiredNames = requiredVariationsList.map(
        (variation: Variation) => variation.name,
      );

      if (variationsError.length > 0) {
        checkVariations(
          'menor',
          variationsError.map((errorItem: Variation) => errorItem.name),
        );
      } else {
        checkVariations('menor', requiredNames);
      }
      result.push(false);
      //console.log('RESULTADO menor', result);
      // return result;
    }
  }
  return result;
};
// functions for login and logout
export const saveLocalStorage = (name: string, data: any) => {
  localStorage.setItem(`${LocalStorageName}${name}`, data);
};

export const getLocalStorage = (name: string) =>
  localStorage.getItem(`${LocalStorageName}${name}`);

export const removeLocalStorage = (name: string) => {
  localStorage.removeItem(`${LocalStorageName}${name}`);
};

// functions for login and logout
export const saveSessionStorage = (name: string, data: any) => {
  sessionStorage.setItem(`${LocalStorageName}${name}`, data);
};

export const getSessionStorage = (name: string) =>
  sessionStorage.getItem(`${LocalStorageName}${name}`);

export const removeSessionStorage = (name: string) => {
  sessionStorage.removeItem(`${LocalStorageName}${name}`);
};

export const getTokenFromLocalStorage = () => {
  const token = getLocalStorage('token') || '';
  if (token) {
    const decryptedToken = decrypt(token);
    return decryptedToken;
  }
  return token;
};

export const getTokenJwt = async (refresh?: boolean) => {
  const token: string = getTokenFromLocalStorage();
  if (!token) {
    await jwtRequest();
    return getTokenFromLocalStorage();
  }
  return token;
};

export const saveTokenJwt = (token: string) => {
  const encryptedToken = encrypt(token);
  saveLocalStorage('token', encryptedToken);
};

export const encrypt = (data: any, serializer = false) => {
  const serializedData = serializer ? JSON.stringify(data) : data;
  return CryptoJS.AES.encrypt(serializedData, secretKey);
};

export const decrypt = (data: string, deserializer = false) => {
  const bytes = CryptoJS.AES.decrypt(data, secretKey);
  const decryptData = bytes.toString(CryptoJS.enc.Utf8);
  return deserializer ? JSON.parse(decryptData) : decryptData;
};

export function returnOnlyNumber(value: string) {
  return value.replace(/\D/g, '');
}

export const sortByAlphabetically = (a: string, b: string) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const makeSubstring = (
  stringName: string,
  numberSize: number,
): string => {
  const strLength = stringName.length;
  const subString = stringName.substring(0, numberSize);
  return `${subString}${strLength > numberSize ? '...' : ''}`;
};

export function maskCep(cep: string) {
  return `${cep.substring(0, 5)}-${cep.substring(5)}`;
}

export function formatMoney(number: any) {
  const numberSplit = number.toFixed(2).split('.');
  numberSplit[0] = numberSplit[0].split(/(?=(?:...)*$)/).join('.');
  return numberSplit.join(',');
}

export function dateToString(dateStr: string) {
  const date = new Date(dateStr);
  const day =
    `${date.getDate()}`.length === 1
      ? `0${date.getDate()}`
      : `${date.getDate()}`;
  const month = Month[date.getMonth()];
  return `${day} de ${month}`;
}
export const extractMinutes = (dateStr: Date) => {
  const date = new Date(dateStr);
  const minutes =
    `${date.getMinutes()}`.length === 1
      ? `0${date.getMinutes()}`
      : `${date.getMinutes()}`;
  return minutes;
};
export const extractHour = (dateStr: Date) => {
  const date = new Date(dateStr);
  const hour =
    `${date.getHours()}`.length === 1
      ? `0${date.getHours()}`
      : `${date.getHours()}`;
  return hour;
};

export const extractHourAndMinutes = (dateStr: string) => {
  const date = new Date(dateStr);
  const hour = extractHour(date);
  const minutes = extractMinutes(date);
  return `${hour}:${minutes}`;
};
// Todo deletar essa função posterior
export const getFilters = (
  filterSegment: string,
  searchBar: string,
  state: string,
  city: string,
  e: MerchantsState[],
) => {
  let result: MerchantsState[] = [];
  if (filterSegment && searchBar && state) {
    if (city) {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) =>
              deliveryArea.state === state &&
              removeSpecialChars(deliveryArea.city) ===
                removeSpecialChars(city),
          ).length > 0 ||
            (merchant.address.state === state &&
              removeSpecialChars(merchant.address.city) ===
                removeSpecialChars(city))) &&
          merchant?.marketSegment?.code === filterSegment,
      );
    } else {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) => deliveryArea.state === state,
          ).length > 0 ||
            (merchant.address.state === state &&
              merchant?.marketSegment?.code === filterSegment)),
      );
    }
  } else if (!filterSegment && !searchBar && !state) {
    result = e;
  } else if (filterSegment && !searchBar && !state) {
    result = e.filter(
      (merchant: MerchantsState) =>
        merchant?.marketSegment?.code === filterSegment,
    );
  } else if (!filterSegment && searchBar && !state) {
    result = e.filter((merchant: MerchantsState) =>
      merchant.name.toUpperCase().includes(searchBar.toUpperCase()),
    );
  } else if (filterSegment && !searchBar && state) {
    if (city) {
      result = e.filter(
        (merchant: MerchantsState) =>
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) =>
              deliveryArea.state === state &&
              removeSpecialChars(deliveryArea.city) ===
                removeSpecialChars(city),
          ).length > 0 ||
            (merchant.address.state === state &&
              removeSpecialChars(merchant.address.city) ===
                removeSpecialChars(city))) &&
          merchant?.marketSegment?.code === filterSegment,
      );
    } else {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) => deliveryArea.state === state,
          ).length > 0 ||
            (merchant.address.state === state &&
              merchant?.marketSegment?.code === filterSegment)),
      );
    }
  } else if (!filterSegment && !searchBar && state) {
    if (city) {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) =>
              deliveryArea.state === state &&
              removeSpecialChars(deliveryArea.city) ===
                removeSpecialChars(city),
          ).length > 0 ||
          (merchant.address.state === state &&
            removeSpecialChars(merchant.address.city) ===
              removeSpecialChars(city)),
      );
    } else {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) => deliveryArea.state === state,
          ).length > 0 ||
            (merchant.address.state === state &&
              merchant?.marketSegment?.code === filterSegment)),
      );
    }
  } else if (!filterSegment && searchBar && state) {
    if (city) {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) =>
              deliveryArea.state === state &&
              removeSpecialChars(deliveryArea.city) ===
                removeSpecialChars(city),
          ).length > 0 ||
            (merchant.address.state === state &&
              removeSpecialChars(merchant.address.city) ===
                removeSpecialChars(city))),
      );
    } else {
      result = e.filter(
        (merchant: MerchantsState) =>
          merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
          (merchant.deliveryAreas.filter(
            (deliveryArea: DeliveryArea) => deliveryArea.state === state,
          ).length > 0 ||
            (merchant.address.state === state &&
              merchant?.marketSegment?.code === filterSegment)),
      );
    }
  } else if (filterSegment && searchBar && !state) {
    result = e.filter(
      (merchant: MerchantsState) =>
        merchant.name.toUpperCase().includes(searchBar.toUpperCase()) &&
        merchant?.marketSegment?.code === filterSegment,
    );
  }
  return result;
};
export const extractDaysHoursAndMinutes = (min: number) => {
  const day = Math.floor(min / 1440) ? `${Math.floor(min / 1440)} dia(s) ` : '';
  const hours = Math.floor((min % 1440) / 60)
    ? `${Math.floor((min % 1440) / 60)}h `
    : '';
  const minutes = Math.floor((min % 1440) % 60)
    ? `${Math.floor((min % 1440) % 60)} min`
    : '';
  return day + hours + minutes;
};

export const getProductsAvailabilityUpdated = (
  products: Product[],
  availability: string,
) => {
  return products.map(product => ({ ...product, availability: availability }));
};

export const getProductAvailabilityUpdated = (
  products: Product[],
  productId: string,
  availability: string,
  category: Category,
) => {
  return products.map(product =>
    product.id === productId && category.availability === 'AVAILABLE'
      ? { ...product, availability: availability }
      : product,
  );
};

export const getProductUpdated = (
  products: Product[],
  productId: string,
  updatedProduct: Product,
) => {
  return products.map(product =>
    product.id === productId
      ? {
          ...product,
          name: updatedProduct.name,
          description: updatedProduct.description,
          price: updatedProduct.price,
          promotion: updatedProduct.promotion,
          isPromotion: updatedProduct.isPromotion,
          stock: {
            ...product.stock,
            active: updatedProduct.stock.active,
            orderMax: updatedProduct.stock.orderMax,
          },
        }
      : product,
  );
};

export const getProductCurrentStockUpdated = (
  products: Product[],
  productId: string,
  stock: number,
) => {
  const resp = products.map(product =>
    product.id === productId
      ? {
          ...product,
          stock: {
            ...product.stock,
            current: stock,
          },
        }
      : product,
  );
  return resp;
};

export const updateOrderProductAvailability = (
  merchantUrl: string,
  productId: string,
  availability: string,
) => {
  const storageProducts: ProductOrder[] = JSON.parse(
    localStorage.getItem(merchantUrl) || '[]',
  );
  const updatedProducts = storageProducts.map(item => {
    return item.productId === productId
      ? {
          ...item,
          availability: availability,
        }
      : item;
  });
  localStorage.setItem(merchantUrl, JSON.stringify(updatedProducts));
};

export const getVariationItemsUpdated = (
  variations: VariationOrder[],
  variationId: string,
  variationItemId: string,
  availability: string,
) => {
  const updatedVariations = variations.map(item =>
    item.variationId === variationId && item.variationItemId === variationItemId
      ? { ...item, variationItemAvailability: availability }
      : item,
  );
  return updatedVariations;
};

export const updateOrderVariationItemAvailability = (
  merchantUrl: string,
  variationId: string,
  variationItemId: string,
  availability: string,
) => {
  const storageProducts: ProductOrder[] = JSON.parse(
    localStorage.getItem(merchantUrl) || '[]',
  );
  const updatedProducts = storageProducts.map(item => {
    return {
      ...item,
      variations: getVariationItemsUpdated(
        item.variations,
        variationId,
        variationItemId,
        availability,
      ),
    };
  });
  localStorage.setItem(merchantUrl, JSON.stringify(updatedProducts));
};

export const hasVariationItemPaused = (variations: VariationOrder[]) => {
  let hasItemPaused = false;
  if (variations && variations.length > 0) {
    for (const value of variations) {
      if (value.variationItemAvailability === 'UNAVAILABLE') {
        hasItemPaused = true;
      }
    }
  }
  return hasItemPaused;
};

export const updateOrderProductCurrentStock = (
  merchantUrl: string,
  productId: string,
  stock: number,
) => {
  const storageProducts: ProductOrder[] = JSON.parse(
    localStorage.getItem(merchantUrl) || '[]',
  );
  const updatedProducts = storageProducts.map(item => {
    return item.productId === productId
      ? {
          ...item,
          stock: {
            ...item.stock,
            current: stock,
          },
        }
      : item;
  });
  localStorage.setItem(merchantUrl, JSON.stringify(updatedProducts));
};
export const updateOrderVariationItemStock = (
  merchantUrl: string,
  variationId: string,
  variationItemId: string,
  stock: number,
) => {
  const storageProducts: ProductOrder[] = JSON.parse(
    localStorage.getItem(merchantUrl) || '[]',
  );
  const updatedProducts = storageProducts.map(item => {
    return {
      ...item,
      variations: getVariationItemsStockUpdated(
        item.variations,
        variationId,
        variationItemId,
        stock,
      ),
    };
  });
  localStorage.setItem(merchantUrl, JSON.stringify(updatedProducts));
};

export const getVariationItemsStockUpdated = (
  variations: VariationOrder[],
  variationId: string,
  variationItemId: string,
  stock: number,
) => {
  const updatedVariations = variations.map(item =>
    item.variationId === variationId && item.variationItemId === variationItemId
      ? { ...item, variationItemStockCurrent: stock }
      : item,
  );
  return updatedVariations;
};

export const verifyVariationItemStock = (
  quantity: number,
  variationItem: VariationItem,
) => {
  if (variationItem.stock.active) {
    if (quantity >= variationItem.stock.current) {
      return false;
    }
    return true;
  }
  return true;
};

export const verifySumCartVariationItemStock = (
  itens: ProductOrder[],
  variationItem: VariationOrder
) => {
  let sum = 0;
  for (const item of itens) {
    for (const variationCart of item.variations) {
      if (
        variationCart.variationItemStockActive &&
        variationCart.variationItemId === variationItem.variationItemId
      ) {
        sum = sum + variationCart.quantity * item.quantity;
      }
    }
  }
  return sum;
};

export const verifyErrosInCart = (itens: ProductOrder[]) => {
  for (const item of itens) {
    if (item.availability === 'UNAVAILABLE') {
      return true;
    } else if (
      item.stock.active &&
      item.stock.orderMax !== 0 &&
      item.quantity > item.stock.orderMax
    ) {
      return true;
    } else if (item.stock.active && item.quantity > item.stock.current) {
      return true;
    } else if (item.variations.length > 0) {
      for (const variationCart of item.variations) {
        if (variationCart.variationItemAvailability === 'UNAVAILABLE') {
          return true;
        } else if (
          variationCart.variationItemStockActive &&
          verifySumCartVariationItemStock(itens, variationCart) >
            variationCart.variationItemStockCurrent
        ) {
          return true;
        }
      }
    }
  }
  return false;
};

export const updateOrderProductStock = (
  merchantUrl: string,
  productId: string,
  stock: Stock,
) => {
  const storageProducts: ProductOrder[] = JSON.parse(
    localStorage.getItem(merchantUrl) || '[]',
  );
  const updatedProducts = storageProducts.map(item => {
    return item.productId === productId
      ? {
          ...item,
          stock: {
            ...item.stock,
            orderMax: stock.orderMax,
          },
        }
      : item;
  });
  localStorage.setItem(merchantUrl, JSON.stringify(updatedProducts));
};

export const buttonClickEvent = (querySelector: string) => {
  const btn = document.querySelector(querySelector) as HTMLButtonElement
  btn.focus()
  btn.click()
}

export const inputElementFocus = (querySelector: string) => {
  const input = document.querySelector(querySelector) as HTMLInputElement
  input.focus()
}

export const formatCEP = (cep: string) => {
  return cep.replace(/^(\d{5})(\d{3})/, '$1-$2');
};

export const convertStateForUf = (state: string) => {
  let uf = '';
  switch(state){
    case 'Acre': uf = 'AC'; break;
    case 'Alagoas': uf = 'AL'; break;
    case 'Amapá': uf = 'AP'; break;
    case 'Amazonas': uf = 'AM'; break;
    case 'Bahia': uf = 'BA'; break;
    case 'Ceará': uf = 'CE'; break;
    case 'Distrito Federal': uf = 'DF'; break;
    case 'Espírito Santo': uf = 'ES'; break;
    case 'Goiás': uf = 'GO'; break;
    case 'Maranhão': uf = 'MA'; break;
    case 'Mato Grosso': uf = 'MT'; break;
    case 'Mato Grosso do Sul': uf = 'MS'; break;
    case 'Minas Gerais': uf = 'MG'; break;
    case 'Pará': uf = 'PA'; break;
    case 'Paraíba': uf = 'PB'; break;
    case 'Paraná': uf = 'PR'; break;
    case 'Pernambuco': uf = 'PE'; break;
    case 'Piauí': uf = 'PI'; break;
    case 'Rio de Janeiro': uf = 'RJ'; break;
    case 'Rio Grande do Norte': uf = 'RN'; break;
    case 'Rio Grande do Sul': uf = 'RS'; break;
    case 'Rond&ohat;nia': uf = 'RO'; break;
    case 'Roraima': uf = 'RR'; break;
    case 'Santa Catarina': uf = 'SC'; break;
    case 'São Paulo': uf = 'SP'; break;
    case 'Sergipe': uf = 'SE'; break;
    case 'Tocantins': uf = 'TO'; break;
  }
  return uf; 
}

export const timeFormater = (time: string) => time.replace(/-/gi, ' ');

export const seveOrUpdateDataAppForNextApp = async (data: IDataApp) => {
  const dataApp = {
    authenticated: data.authenticated,
    activeToastSignOut: data.activeToastSignOut,
    toastSignOutMessage: data.toastSignOutMessage,
    info: data.info
  }
  saveSessionStorage('dataApp', encrypt(dataApp, true))
}